import { Link } from '@remix-run/react';
import cx from 'classnames';

interface Props {
  slug: string;
  className?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

const PostLink = ({ slug, className, children, style }: Props) => {
  return (
    <Link style={style} to={`/p/${slug}`} className={cx(className)} prefetch="intent">
      {children}
    </Link>
  );
};

export default PostLink;
